import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { ShareDataTypes } from "../../../../Schema/share.types";
import { openModal } from "../../modal/modal";
import { ModalNames } from "../../../../Constants/modalNames";

export type ShareLoadAction = {
  type: string;
  payload: { id?: number | string;share_token: string; shouldOpenModal?: boolean };
};

export type ShareData = {
  data: ShareDataTypes;
};

const Share = new ReduxFetchState<ShareData, { id?: number | string;share_token: string  }, any>(
  "share",
);

export function* watchShare(action: ShareLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const { id,share_token, shouldOpenModal } = action.payload;
    const data: ShareData = yield axios({
      url: `/api/v1/ai/user-sub-service/share/${share_token}${id ? `?chat_id=${id}` :""}`,
      method: "GET",
      headers: { lang },
    });

    yield put(Share.actions.loadSuccess({ data: data.data }));
    if (shouldOpenModal) {
      yield put(
        openModal({
          name: ModalNames.CopyLinkModal,
          modalProps: { unique_token: data.data.unique_token },
        }),
      );
    }
  } catch (e: any) {
    alert({ message: "مشکلی پیش آمده", type: "error" });
    yield put(Share.actions.loadFailure(e.message));
  }
}

export function* shareSagas() {
  yield takeEvery(Share.actionTypes.load, watchShare);
}

export function useShare() {
  const { loading, data, ...shareState } = useAppSelector(
    (state) => state.share,
  );
  const dispatch = useAppDispatch();

  const dispatchShare = useCallback(
    (data: { id?: number | string; shouldOpenModal?: boolean; share_token: string }) => {
      dispatch(Share.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...shareState,
    dispatchShare,
    shareLoading: loading,
    shareData: data,
  };
}

export const {
  actionTypes: shareActionsTypes,
  actions: shareActions,
  reducer: shareReducer,
} = Share;
